module.exports = __webpack_public_path__ + "static/img/icon_house@2x.d5fab98.png";